import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { enderecoCanonico, paginaPublica } from './paginasPublicas';

/**
 * A "CABEÇA" DE CADA ROTA (25/10/2026, encontrabilidade): na página pública, o <title>, a descrição, o `canonical` e as
 * `og:*` dela, e `robots: index, follow`; em toda outra rota (área logada, prova, entrar…), `robots: noindex, nofollow` e
 * sem `canonical`. O HTML pronto das páginas públicas (`scripts/prerender-publicas.mjs`) é fotografado DEPOIS disto — é
 * assim que o robô que não roda JavaScript recebe a cabeça certa.
 */
function meta(atributo: 'name' | 'property', nome: string, conteudo: string | null) {
  let el = document.head.querySelector(`meta[${atributo}="${nome}"]`) as HTMLMetaElement | null;
  if (conteudo == null) { el?.remove(); return; }
  if (!el) { el = document.createElement('meta'); el.setAttribute(atributo, nome); document.head.appendChild(el); }
  el.setAttribute('content', conteudo);
}
function canonical(href: string | null) {
  let el = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (href == null) { el?.remove(); return; }
  if (!el) { el = document.createElement('link'); el.rel = 'canonical'; document.head.appendChild(el); }
  el.href = href;
}

export function CabecaDaRota() {
  const { pathname } = useLocation();
  useEffect(() => {
    const p = paginaPublica(pathname);
    if (p) {
      const url = enderecoCanonico(p.caminho);
      document.title = p.titulo;
      meta('name', 'description', p.descricao);
      meta('name', 'robots', 'index, follow');
      canonical(url);
      meta('property', 'og:url', url);
      meta('property', 'og:title', p.caminho === '/' ? 'Portal Simulados' : p.titulo);
      meta('property', 'og:description', p.descricao);
      meta('name', 'twitter:title', p.caminho === '/' ? 'Portal Simulados' : p.titulo);
      meta('name', 'twitter:description', p.descricao);
    } else {
      meta('name', 'robots', 'noindex, nofollow');
      canonical(null);
    }
  }, [pathname]);
  return null;
}
